import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { auth as authApi } from '../services/api';

const Sidebar = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch (err) {
      console.error('Logout failed', err);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      onLogout();
      navigate('/login');
    }
  };

  const navLinkClass = ({ isActive }) =>
    `w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition duration-200 ${
      isActive
        ? 'bg-blue-600 text-white shadow-md shadow-blue-200'
        : 'text-gray-500 hover:bg-gray-100'
    }`;

  return (
    <aside className="w-64 bg-white border-r min-h-screen hidden md:flex flex-col sticky top-0">
      {/* Logo */}
      <div className="p-6 border-b">
        <div className="flex items-center gap-2">
        <div className="w-8 h-8 flex items-center justify-center">
          <img 
            src="/logo_pantera.jpg" 
            alt="Panthera Logo" 
            className="w-8 h-8 object-contain"
          />
        </div>
          <h1 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">
            Admin Panel
          </h1>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-4 space-y-2">
        <NavLink to="/services" className={navLinkClass}>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          Log Servis
        </NavLink>

        {user?.role === 'superadmin' && (
          <NavLink to="/templates" className={navLinkClass}>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Template &amp; Import
          </NavLink>
        )}
{user?.role === 'superadmin' && (
  <NavLink to="/promotion-groups" className={navLinkClass}>
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7h18M3 12h18M3 17h18" />
    </svg>
    Promotion Groups
  </NavLink>
)}

        {['superadmin', 'admin'].includes(user?.role) && (
          <div className="pt-4 mt-4 border-t border-gray-100">
            <p className="px-4 text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Master Data</p>
            <div className="space-y-2">
              <NavLink to="/master-ahass" className={navLinkClass}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                {user?.role === 'superadmin' ? 'Master AHASS' : 'Manajemen AHASS'}
              </NavLink>

              {user?.role === 'superadmin' && (
                <>
                  <NavLink to="/master-bikes" className={navLinkClass}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Master Motor
                  </NavLink>

                  <NavLink to="/master-spare-parts" className={navLinkClass}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                    Master Spare Part
                  </NavLink>

                  <NavLink to="/global-master-spare-parts" className={navLinkClass}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Global Master Parts
                  </NavLink>

                  <NavLink to="/master-bike-parts" className={navLinkClass}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Mapping & Harga
                  </NavLink>
                </>
              )}

              <NavLink to="/master-stocks" className={navLinkClass}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                </svg>
                Manajemen Stok
              </NavLink>

              {['admin', 'superadmin'].includes(user?.role) && (
                <NavLink to="/master-users" className={navLinkClass}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-2a6 6 0 0112 0v2zm0 0h6v-2a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                  Master Users
                </NavLink>
              )}
              {user?.role === 'superadmin' && (
                <NavLink to="/master-customers" className={navLinkClass}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  Master Customer
                </NavLink>
              )}
            </div>
          </div>
        )}
      </nav>

      {/* User Info */}
      <div className="p-4 border-t">
        <div className="bg-gray-50 p-4 rounded-xl">
          <p className="text-sm font-bold text-gray-800 truncate">{user?.fullname || 'Superadmin'}</p>
          <p className="text-xs text-blue-600 font-medium capitalize">{user?.role || 'Admin'}</p>
          <div className="mt-3 flex gap-2">
            <NavLink
              to="/profile"
              className="flex-1 bg-white border border-gray-200 hover:bg-gray-100 text-gray-700 py-1.5 rounded-lg text-xs font-bold transition duration-200 text-center"
            >
              Profil
            </NavLink>
            <button
              onClick={handleLogout}
              className="flex-1 bg-white border border-gray-200 hover:bg-red-50 hover:text-red-600 text-gray-700 py-1.5 rounded-lg text-xs font-bold transition duration-200"
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
